// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerStartersCustomerType = {
    All: 'All',
    Members: 'Members',
    BrandPartners: 'BrandPartners',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerStartersCustomerCategoryFilter = {
    All: 'All',
    Consultants: 'Consultants',
    EndCustomers: 'EndCustomers',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerPersonalGroupListingPersonalGroupGroupFilter = {
    All: 'All',
    Actives: 'Actives',
    Recruits: 'Recruits',
    Reactives: 'Reactives',
    Inactives: 'Inactives',
    Leaders: 'Leaders',
    Inactive1Period: 'Inactive1Period',
    Inactive2Period: 'Inactive2Period',
    Inactive3Period: 'Inactive3Period',
    SalesForceMembers: 'SalesForceMembers',
    ActiveMembers: 'ActiveMembers',
    ReactivatedMembers: 'ReactivatedMembers',
    RecruitsMembers: 'RecruitsMembers',
    ReactivatedEndCustomer: 'ReactivatedEndCustomer',
    FirstBpEndCustomer: 'FirstBpEndCustomer',
    ActiveInPeriodWithoutRecruitsAndReactivatedEndCustomers: 'ActiveInPeriodWithoutRecruitsAndReactivatedEndCustomers',
    BcmAllBrandPartners: 'BcmAllBrandPartners',
    BcmActivesBrandPartners: 'BcmActivesBrandPartners',
    BcmRecruitsBrandPartners: 'BcmRecruitsBrandPartners',
    BcmReactivatedBrandPartners: 'BcmReactivatedBrandPartners',
    BcmInactive1PeriodBrandPartners: 'BcmInactive1PeriodBrandPartners',
    BcmInactive2PeriodBrandPartners: 'BcmInactive2PeriodBrandPartners',
    BcmInactive3PeriodBrandPartners: 'BcmInactive3PeriodBrandPartners',
    BcmAllMembers: 'BcmAllMembers',
    BcmActivesMembers: 'BcmActivesMembers',
    BcmRecruitsMembers: 'BcmRecruitsMembers',
    BcmReactivatedMembers: 'BcmReactivatedMembers',
    BcmInactive1PeriodMembers: 'BcmInactive1PeriodMembers',
    BcmInactive2PeriodMembers: 'BcmInactive2PeriodMembers',
    BcmInactive3PeriodMembers: 'BcmInactive3PeriodMembers',
    Inactive1PeriodMembers: 'Inactive1PeriodMembers',
    Inactive2PeriodMembers: 'Inactive2PeriodMembers',
    Inactive3PeriodMembers: 'Inactive3PeriodMembers',
    AllEndCustomers: 'AllEndCustomers',
    Inactive1PeriodEndCustomers: 'Inactive1PeriodEndCustomers',
    Inactive2PeriodEndCustomers: 'Inactive2PeriodEndCustomers',
    Inactive3PeriodEndCustomers: 'Inactive3PeriodEndCustomers',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerBeautyRoutinePersonalSubscriptionsOverviewCustomerSubscriptionStatus = {
    ActiveSubscriptionCustomers: 'ActiveSubscriptionCustomers',
    CancelledSubscritionLastPeriod: 'CancelledSubscritionLastPeriod',
    WithoutSubscription: 'WithoutSubscription',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerBeautyRoutineWellnessSubscriptionsOverviewSubscriptionState = {
    Active: 'Active',
    Renewed: 'Renewed',
    Canceled: 'Canceled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerBeautyRoutineIntroduceBeautyRoutineOverviewConversionType = {
    NonConverted: 'NonConverted',
    Converted: 'Converted',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerBeautyRoutineImproveSalesOverviewConversionType = {
    NonConverted: 'NonConverted',
    Converted: 'Converted',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerBeautyRoutineImproveSalesOverviewUpsellType = {
    Upsell: 'Upsell',
    CrossSell: 'CrossSell',
    Repurchase: 'Repurchase',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerBeautyRoutineImproveSalesOverviewCategory = {
    NovagePlus: 'NovagePlus',
    Wellness: 'Wellness',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerBeautyRoutineDownlineOverviewProductCategory = {
    NovagePlus: 'NovagePlus',
    Wellness: 'Wellness',
    NovagePlusAndWellness: 'NovagePlusAndWellness',
    ActiveNotBuyingBeautyRoutine: 'ActiveNotBuyingBeautyRoutine',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerBeautyCommunityCustomersSimplifiedDownlineType = {
    FirstLevel: 'FirstLevel',
    PersonalGroup: 'PersonalGroup',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerBeautyCommunityCustomersSimplifiedCustomerType = {
    All: 'All',
    Members: 'Members',
    BrandPartners: 'BrandPartners',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerBeautyCommunityCustomersDownlineType = {
    FirstLevel: 'FirstLevel',
    PersonalGroup: 'PersonalGroup',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerBeautyCommunityCustomersCustomerType = {
    All: 'All',
    Members: 'Members',
    BrandPartners: 'BrandPartners',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var MobileOfficePersonalGroupListingGamifiedWelcomeProgramPersonalGroupStepListRecordDtoStatus = {
    Starter: 'Starter',
    InProgress: 'InProgress',
    Completed: 'Completed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var MobileOfficePersonalGroupListingContactInfoDtoSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var MobileOfficePersonalGroupListingContactInfoDtoVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var MobileOfficePersonalGroupListingContactInfoDtoAcquisition = {
    Oriflame: 'Oriflame',
    Guest: 'Guest',
    Referral: 'Referral',
    Pbs: 'Pbs',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var MobileOfficeMyBusinessDownlineMmKpiItemDtoCustomerCategory = {
    Consultant: 'Consultant',
    EndConsumer: 'EndConsumer',
    EndCustomer: 'EndCustomer',
    Employee: 'Employee',
    Anonymous: 'Anonymous',
    Other: 'Other',
    Invitation: 'Invitation',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var MobileOfficeConfigurationModulesVisibilityDtoEarningsOnDashboardVisitorSegmentsItem = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var MobileOfficeCommissionPlansSeminarsPeriodEvaluationStatusDtoPeriodStatus = {
    NotCompleted: 'NotCompleted',
    Completed: 'Completed',
    ActiveNotCompleted: 'ActiveNotCompleted',
    ActiveCompleted: 'ActiveCompleted',
    NotActive: 'NotActive',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var MobileOfficeCommissionPlansSeminarsNewTitleBracketStatusDtoNewMaxTitleReached = {
    A: 'A',
    B: 'B',
    C: 'C',
    CS: 'CS',
    D: 'D',
    E: 'E',
    F: 'F',
    G: 'G',
    H: 'H',
    I: 'I',
    J: 'J',
    K: 'K',
    L: 'L',
    M: 'M',
    N: 'N',
    O: 'O',
    P: 'P',
    Q: 'Q',
    R: 'R',
    S: 'S',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var MobileOfficeCommissionPlansSeminarsNewTitleBracketStatusDtoNewMaxTitleTarget = {
    A: 'A',
    B: 'B',
    C: 'C',
    CS: 'CS',
    D: 'D',
    E: 'E',
    F: 'F',
    G: 'G',
    H: 'H',
    I: 'I',
    J: 'J',
    K: 'K',
    L: 'L',
    M: 'M',
    N: 'N',
    O: 'O',
    P: 'P',
    Q: 'Q',
    R: 'R',
    S: 'S',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var MobileOfficeCommissionPlansSeminarsNewComerBracketStatusDtoTargetDiscountRateLevel = {
    LevelBasic: 'LevelBasic',
    Level10: 'Level10',
    Level20: 'Level20',
    Level30: 'Level30',
    Level40: 'Level40',
    Level50: 'Level50',
    Level60: 'Level60',
    LevelMax: 'LevelMax',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var MobileOfficeCommissionPlansSeminarsNewComerBracketStatusDtoNewComerType = {
    NewBrandPartner: 'NewBrandPartner',
    UpgradedMember: 'UpgradedMember',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var MobileOfficeCommissionPlansSeminarsManagerBracketStatusDtoTargetDiscountRateLevel = {
    LevelBasic: 'LevelBasic',
    Level10: 'Level10',
    Level20: 'Level20',
    Level30: 'Level30',
    Level40: 'Level40',
    Level50: 'Level50',
    Level60: 'Level60',
    LevelMax: 'LevelMax',
};

